import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'

const FieldSelectItemCategory = (props) => {
  const { children, label, isOpen, measure, onClick } = props

  useEffect(() => {
    measure && measure()
  }, [label])

  return (
    <div
      className="select-item-category"
      onClick={onClick}>
      <div className="select-category-handle">
        {label}
        <FontAwesomeIcon icon={isOpen ? 'chevron-up' : 'chevron-down'} />
      </div>
      {children}
    </div>
  )
}

export default FieldSelectItemCategory
